const initialState = () => ({
  companyPricing: null,
  pricings: [], // todos los planes
})

export default initialState
